import React from 'react'
import styles from './button.module.css'
import classNames from 'classnames'

interface ButtonProps {
	text: string
	arrow?: boolean // Make arrow optional
	active?: boolean
	onClick?: () => void
}

const Button: React.FC<ButtonProps> = ({
	text,
	arrow = false,
	active = false,
	onClick,
}) => {
	const buttonClass = classNames(styles.button, {
		[styles.buttonActive]: active,
	})

	return (
		<button className={buttonClass} onClick={onClick}>
			{arrow ? (
				<>
					<span className={styles.button__text__arrow}>{text}</span>
					<span className={styles.button__arrow}>
						<img src='http://pitchinvasion.ru/files/icons/arrow_white.svg' />
					</span>
				</>
			) : (
				<>
					<span className={styles.button__text}>{text}</span>
				</>
			)}
		</button>
	)
}

export default Button
